


export const GITHUB_LINK = "https://github.com/mkslge/ClassFinder"